/**
 * Renders contextual child menu items for the selected left-nav module.
 * This component is presentational and emits child selection back to the parent container.
 */
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { LeftNavSubItem } from '../../models/left-nav-item.model';

@Component({
    selector: 'sb-left-nav-flyout-menu',
    templateUrl: './left-nav-flyout-menu.component.html',
    styleUrls: ['./left-nav-flyout-menu.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LeftNavFlyoutMenuComponent {
    @Input() parentLabel = '';
    @Input() children: LeftNavSubItem[] = [];
    @Input() activeItemId: string | null = null;

    @Output() childSelected = new EventEmitter<LeftNavSubItem>();

    onChildSelect(child: LeftNavSubItem): void {
        this.childSelected.emit(child);
    }
}
